module.exports = __webpack_public_path__ + "static/media/clear-day.aa5c1452.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weather/clear-day.png
// module id = 6650
// module chunks = 0